import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
// import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './search-select.scss';
import Button from '../button/button';
import {
  AcceptIcon,
  EditIcon,
  PlusIcon,
  SearchIcon,
  // ShortDownIcon,
} from '../icons/icons';
import OutsideClick from '../outside-click/outside-click';
import Checkbox from '../custom-checkbox/custom-checkbox';
import DynamicTooltip from '../tooltip/dynamic-tooltip';

function MultiSearchSelect({
  label,
  data,
  onChange,
  defaultValue,
  selectProduct,
  t,
  classNames,
  enableLabel,
  selectStyle,
  containerClassName,
  required,
  placeholder,
  arrowColor,
  errorMessage,
  children,
  disabled,
  enableRemove,
  handleApplyAll,
  enableBulk,
  searchPlaceholder,
  value,
  onDataChange,
}) {
  const selectPackageType = useRef(null);
  const [query, setQuery] = useState('');
  const [selectedLabel, setSelectedlabel] = useState(defaultValue);
  const [eventValue, setEventValue] = useState();
  const [isToggle, setIsToggle] = useState(!selectProduct);
  const [selectedValue, setSelectedValue] = useState('');
  // const [t1] = useTranslation('manageorders');

  // ADDED (multi select)
  const [multiValues, setMultiValues] = useState([]);
  const [multiLabels, setMultiLabels] = useState([]);

  const selectRef = useRef(null);
  const optionBox = useRef(null);
  const selectListRef = useState(null);
  const [selectListWidth, setSelectListWidth] = useState(0);
  const [optionTop, setOptionTop] = useState(0);
  const searchbox = useRef(null);
  const [localData, setLocalData] = useState(data || []);

  useEffect(() => {
    if (data && data.length) {
      setLocalData(data);
    }
  }, [data]);

  useLayoutEffect(() => {
    if (eventValue && optionBox.current && selectPackageType.current) {
      const triggerRect = selectPackageType.current.getBoundingClientRect();
      const optionRect = optionBox.current.getBoundingClientRect();

      const optionBoxHeight = optionRect.height;

      const shouldOpenTop =
        triggerRect.top + triggerRect.height + optionBoxHeight >
        window.innerHeight;

      setOptionTop(
        shouldOpenTop
          ? triggerRect.top - optionBoxHeight
          : triggerRect.top + triggerRect.height
      );
    }
  }, [eventValue]);

  const getPosition = () => {
    setEventValue(selectPackageType.current.getBoundingClientRect());

    const el = document.querySelector('.dialog-wrapper');
    if (el) el.style.overflow = 'hidden';

    document.body.style.overflow = 'hidden';
  };

  useEffect(() => {
    setSelectedlabel(value);
    if (enableLabel) {
      setSelectListWidth(selectRef.current?.getBoundingClientRect().width);
    } else {
      setSelectListWidth(null);
    }
  }, [value, enableLabel]);

  useEffect(() => {
    if (Array.isArray(value)) {
      setMultiValues(value);
      setMultiLabels(value);
    }
  }, [value]);

  const togglePopover = () => {
    setEventValue(selectPackageType.current.getBoundingClientRect());
    document.body.style.overflow = 'hidden';
    setQuery('');
    getPosition();

    if (enableLabel) {
      setSelectListWidth(selectRef.current?.getBoundingClientRect().width);
    } else {
      setSelectListWidth(null);
    }
  };

  const handleChange = (e) => {
    setSelectedValue(e.target.value);
    togglePopover(e);
    getPosition();
    searchbox.current.value = e.target.value;
    setQuery(e.target?.value?.toLowerCase());
  };

  const handleRemoveSelectedValue = () => {
    setSelectedlabel('');
    setSelectedValue('');
    setQuery('');
    setIsToggle(true);

    // ADDED
    setMultiValues([]);
    setMultiLabels([]);

    onChange({ target: { value: '', label: '' } });
    setTimeout(() => {
      if (selectPackageType.current) {
        selectPackageType.current.focus();
      }
    }, 200);
  };

  // ADDED (multi select handler)
  const handleMultiSelect = (e, val) => {
    e.stopPropagation();

    let updatedValues = [...multiValues];
    let updatedLabels = [...multiLabels];

    const exists = updatedValues.includes(val.value);

    if (exists) {
      updatedValues = updatedValues.filter((v) => v !== val.value);
      updatedLabels = updatedLabels.filter((l) => l !== val.label);
    } else {
      updatedValues.push(val.value);
      updatedLabels.push(val.label);
    }

    setMultiValues(updatedValues);
    setMultiLabels(updatedLabels);

    onChange({
      target: {
        value: updatedValues,
        label: updatedLabels,
      },
    });
  };

  const getApplyAllLabel = (e) => {
    const target = e?.target;
    handleApplyAll({
      target: {
        value: target?.value,
        label: target?.innerText,
      },
    });
    setEventValue(null);
    setIsToggle(false);
    setQuery(target?.innerText?.toLowerCase());
  };

  const handleClose = () => {
    setEventValue(null);
    document.body.style.overflow = 'auto';
    const el = document.querySelector('.dialog-wrapper');
    if (el) {
      el.style.overflow = 'auto';
    }
    if (
      !selectedLabel.length ||
      (Array.isArray(selectedLabel) && selectedLabel.length === 0)
    ) {
      setQuery('');
    } else {
      const labelString = Array.isArray(selectedLabel)
        ? selectedLabel.join(',')
        : selectedLabel;

      if (query !== labelString?.toLowerCase()) {
        setQuery(labelString?.toLowerCase());
      }
    }
  };

  const filteredDDList = localData?.filter((val) =>
    val?.label?.toLowerCase()?.includes(query)
  );

  const displayValueWhenSelectedLabelIsEmpty = placeholder || label;

  const [firstLabel, ...restLabels] = multiLabels;

  // let displayValue = '';

  // if (firstLabel) {
  //   if (restLabels.length) {
  //     displayValue = `${firstLabel} +${restLabels.length}`;
  //   } else {
  //     displayValue = firstLabel;
  //   }
  // } else if (!selectedLabel.length) {
  //   displayValue = displayValueWhenSelectedLabelIsEmpty;
  // } else {
  //   displayValue = selectedLabel;
  // }

  const renderDisplayValue = () => {
    if (firstLabel) {
      return (
        <>
          <span className="primary-label">{firstLabel}</span>
          {restLabels.length > 0 && (
            <span className="extra-count"> +{restLabels.length}</span>
          )}
        </>
      );
    }

    if (!selectedLabel.length) {
      return (
        <span>
          {displayValueWhenSelectedLabelIsEmpty}
          <span className="required">*</span>
        </span>
      );
    }

    return <span>{selectedLabel}</span>;
  };
  return (
    <>
      {(enableLabel || isToggle || !selectedLabel.length) && (
        <div
          className={`search-select${
            enableLabel || selectStyle ? ' select' : ''
          }${containerClassName ? ` ${containerClassName}` : ''}${
            disabled || eventValue ? ' disablled' : ''
          }`}
          ref={selectRef}
        >
          {enableLabel && label && (
            <div className="d-flex justify-between align-center">
              <label>
                {label} {required && <span className="required">*</span>}
              </label>
              {children}
            </div>
          )}
          <div className="search-select-box select">
            <button
              className={`search-select-button ${classNames}${
                enableRemove && !selectedLabel.length
                  ? ' w-100-20'
                  : ' w-100-40'
              }${enableLabel ? '' : ' pl-10'}`}
              type="button"
              onClick={togglePopover}
              id="actionPopover"
              ref={selectPackageType}
              disabled={disabled || eventValue}
            >
              <span className="search-select-value-display disable-pointer d-flex align-center">
                {renderDisplayValue()}
              </span>
            </button>

            {enableRemove && selectedLabel.length > 0 && (
              <button
                type="button"
                className="clear-selected"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveSelectedValue();
                }}
                style={{ color: arrowColor }}
                disabled={disabled || eventValue}
              >
                &times;
              </button>
            )}

            {enableLabel && (
              <button
                className="arrow bg-transparent border-none d-flex px-0"
                type="button"
                onClick={togglePopover}
                disabled={disabled || eventValue}
              >
                {/* <ShortDownIcon
                  color={arrowColor || enableLabel ? '' : '#0088FA'}
                /> */}
                <PlusIcon color="#0088FA" />
              </button>
            )}

            {!selectedLabel.length
              ? !enableLabel && (
                  <button
                    className="arrow bg-transparent border-none d-flex px-0"
                    type="button"
                    onClick={togglePopover}
                    disabled={disabled || eventValue}
                  >
                    {/* <ShortDownIcon
                      color={arrowColor || enableLabel ? '' : '#0088FA'}
                    /> */}
                    <PlusIcon color="#0088FA" />
                  </button>
                )
              : !enableLabel && (
                  <Button
                    icon={<EditIcon />}
                    className="p-0 ml-10 position-absolute t-0 r-0 b-0 w-auto m-w-auto pl-0 mr-5"
                    onClick={(e) => {
                      setIsToggle(true);
                      togglePopover(e);
                    }}
                    disabled={
                      disabled ||
                      eventValue ||
                      (!enableLabel && !isToggle && selectedLabel.length)
                    }
                  />
                )}
          </div>
        </div>
      )}

      {!enableLabel && !isToggle && selectedLabel.length && (
        <div
          className={`search-select${
            enableLabel || selectStyle ? ' select' : ''
          }${containerClassName ? ` ${containerClassName}` : ''}${
            disabled || eventValue ? ' disablled' : ''
          }`}
          ref={selectRef}
        >
          {enableLabel && <label>{label}</label>}
          <span className={`search-select-box ${classNames}`}>
            <span className="search-select-value pl-6 text-limit">
              {selectedLabel.length ? label : selectedLabel}
            </span>
            {!disabled && enableRemove && (
              <button
                type="button"
                className="clear-selected"
                style={{ color: arrowColor }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveSelectedValue();
                }}
              >
                &times;
              </button>
            )}
            {!disabled && (
              <Button
                icon={<EditIcon />}
                className="p-0 ml-10 position-absolute"
                onClick={(e) => {
                  setIsToggle(true);
                  togglePopover(e);
                }}
                disabled={disabled || eventValue}
              />
            )}
          </span>
        </div>
      )}

      {errorMessage !== '' && <p className="error-message">{errorMessage}</p>}

      {eventValue && (
        <>
          <div className="search-select-mask" />
          <OutsideClick onClickOutside={handleClose}>
            <div
              className={`search-select-popover${enableLabel ? ' select' : ''}`}
              style={{
                left: eventValue.left,
                top: optionTop,
                width: selectListWidth,
              }}
              ref={optionBox}
            >
              <div className="search-select-search" ref={selectListRef}>
                <input
                  type="text"
                  onChange={handleChange}
                  ref={searchbox}
                  className="search-select-search-box"
                  placeholder={searchPlaceholder}
                />
                {classNames && query?.trim() && !filteredDDList?.length ? (
                  <button
                    className="accept"
                    type="button"
                    disabled={query === ''}
                    onClick={() => {
                      const newLabel = selectedValue || query;
                      const newValue = newLabel;

                      // check if already exists
                      const exists = localData.some(
                        (item) =>
                          item?.label?.toLowerCase() === newLabel?.toLowerCase()
                      );

                      let updatedData = localData;

                      if (!exists) {
                        const newItem = { label: newLabel, value: newValue };
                        updatedData = [...localData, newItem];
                        setLocalData(updatedData);
                        if (onDataChange) {
                          onDataChange(updatedData);
                        }
                      }

                      const updatedValues = [...multiValues, newValue];
                      const updatedLabels = [...multiLabels, newLabel];
                      setMultiValues(updatedValues);
                      setMultiLabels(updatedLabels);
                      onChange({
                        target: {
                          value: updatedValues,
                          label: updatedLabels,
                        },
                      });

                      handleClose();
                    }}
                  >
                    <AcceptIcon color="#0288FA" />
                  </button>
                ) : (
                  <span className="arrow">
                    <SearchIcon />
                  </span>
                )}
              </div>

              {filteredDDList?.length ? (
                <ul className={enableBulk ? 'enaable-bulk' : ''}>
                  {filteredDDList.map((val) => (
                    <li key={val.value}>
                      <Checkbox
                        value={val.value}
                        checked={multiValues.includes(val.value)}
                        onClick={(e) => {
                          handleMultiSelect(e, val);
                        }}
                        label={
                          val?.value ? (
                            <DynamicTooltip
                              content={val?.label}
                              zIndex={9999999}
                              wrapperClass="checkbox-tooltip-wrapper d-flex"
                              className="tooltip-maxcontent"
                            >
                              <span>{val?.label}</span>
                            </DynamicTooltip>
                          ) : (
                            <span>{val?.label}</span>
                          )
                        }
                        labelClassName="text-limit"
                      />

                      {enableBulk && (
                        <button
                          type="button"
                          value={val.value}
                          onClick={(e) => {
                            getApplyAllLabel(e);
                            handleClose();
                          }}
                          className="apply-all"
                        >
                          <span className="text">
                            {t(
                              'manageordersscreen.filterbtn.filteroption.applyall'
                            )}
                          </span>
                        </button>
                      )}
                    </li>
                  ))}
                </ul>
              ) : null}
            </div>
          </OutsideClick>
        </>
      )}
    </>
  );
}

export default React.memo(MultiSearchSelect);

MultiSearchSelect.propTypes = {
  label: PropTypes.string,
  data: PropTypes.instanceOf(Array),
  onChange: PropTypes.func,

  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),

  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),

  selectProduct: PropTypes.bool,
  t: PropTypes.func,
  classNames: PropTypes.string,
  enableLabel: PropTypes.bool,
  selectStyle: PropTypes.bool,
  containerClassName: PropTypes.string,
  required: PropTypes.bool,
  searchPlaceholder: PropTypes.string,
  arrowColor: PropTypes.string,
  errorMessage: PropTypes.string,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  enableRemove: PropTypes.bool,
  placeholder: PropTypes.string,
  handleApplyAll: PropTypes.func,
  enableBulk: PropTypes.bool,
  onDataChange: PropTypes.func,
};
MultiSearchSelect.defaultProps = {
  label: '',
  data: [],
  onChange: () => {},
  defaultValue: [],
  value: [],
  searchPlaceholder: '',
  selectProduct: false,
  t: () => {},
  classNames: '',
  enableLabel: false,
  selectStyle: false,
  containerClassName: '',
  required: false,
  placeholder: '',
  arrowColor: '',
  errorMessage: '',
  children: null,
  disabled: false,
  enableRemove: false,
  handleApplyAll: () => {},
  enableBulk: false,
  onDataChange: () => {},
};
